import { Record, Union } from "./fable_modules/fable-library-js.4.24.0/Types.js";
import { obj_type, record_type, option_type, union_type, string_type } from "./fable_modules/fable-library-js.4.24.0/Reflection.js";
import { LoginRequest_$reflection, LoginRequest, GenericResponse_$reflection } from "./Shared/ApiDataTypes.js";
import { FetchError, FetchError_$reflection } from "./fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { Result_MapError, FSharpResult$2 } from "./fable_modules/fable-library-js.4.24.0/Result.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "./fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "./fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { Auto_generateBoxedDecoderCached_Z6670B51, Auto_generateBoxedDecoder_Z6670B51 } from "./fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { corsProps, testRedirect, extraCoders } from "./Promises.js";
import { PromiseBuilder__Delay_62FBFDE1 as PromiseBuilder__Delay_62FBFDE1_1, PromiseBuilder__Run_212F1D4B as PromiseBuilder__Run_212F1D4B_1 } from "./fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise as promise_1 } from "./fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { Helper_fetch, Helper_withContentTypeJson, Helper_withProperties } from "./fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { Types_RequestProperties } from "./fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { keyValueList } from "./fable_modules/fable-library-js.4.24.0/MapUtil.js";
import { singleton as singleton_1, cons, ofArray, empty } from "./fable_modules/fable-library-js.4.24.0/List.js";
import { some, unwrap, map, defaultArg } from "./fable_modules/fable-library-js.4.24.0/Option.js";
import { toString } from "./fable_modules/Thoth.Json.10.2.0/Encode.fs.js";
import { Auto_generateBoxedEncoder_437914C6, Auto_generateBoxedEncoderCached_437914C6 } from "./fable_modules/Thoth.Json.10.2.0/Encode.fs.js";
import { fromString } from "./fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { createObj, uncurry2 } from "./fable_modules/fable-library-js.4.24.0/Util.js";
import { createElement } from "react";
import React from "react";
import { reactApi } from "./fable_modules/Feliz.2.8.0/Interop.fs.js";
import { useEffectOnce } from "./fable_modules/Feliz.2.8.0/Internal.fs.js";
import { MuiHelpers_createElement } from "./fable_modules/Feliz.MaterialUI.5.13.7-alpha.8/Mui.fs.js";
import { TextField, Paper } from "@mui/material";
import { singleton, append, delay, toList } from "./fable_modules/fable-library-js.4.24.0/Seq.js";
import { RouterModule_nav } from "./fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { loadingIndicator } from "./ViewHelpers.js";

class ValidateState extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Processing", "Success", "Expired", "Failed"];
    }
}

function ValidateState_$reflection() {
    return union_type("Activate.ValidateState", [], ValidateState, () => [[], [], [], [["Item", string_type]]]);
}

class ActivateState extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["NotInitiated", "Processing", "Success", "Failed"];
    }
}

function ActivateState_$reflection() {
    return union_type("Activate.ActivateState", [], ActivateState, () => [[], [], [], [["Item", string_type]]]);
}

class Model extends Record {
    constructor(Token, Validate, Activate, Password, PasswordRepeat, ErrorMsg) {
        super();
        this.Token = Token;
        this.Validate = Validate;
        this.Activate = Activate;
        this.Password = Password;
        this.PasswordRepeat = PasswordRepeat;
        this.ErrorMsg = ErrorMsg;
    }
}

function Model_$reflection() {
    return record_type("Activate.Model", [], Model, () => [["Token", string_type], ["Validate", ValidateState_$reflection()], ["Activate", ActivateState_$reflection()], ["Password", string_type], ["PasswordRepeat", string_type], ["ErrorMsg", option_type(string_type)]]);
}

class Message extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["UpdatePassword", "UpdatePasswordRepeat", "ValidateResponse", "ActivateResponse", "DismissError"];
    }
}

function Message_$reflection() {
    return union_type("Activate.Message", [], Message, () => [[["Item", string_type]], [["Item", string_type]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [GenericResponse_$reflection(), FetchError_$reflection()], FSharpResult$2, () => [[["ResultValue", GenericResponse_$reflection()]], [["ErrorValue", FetchError_$reflection()]]])]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [GenericResponse_$reflection(), FetchError_$reflection()], FSharpResult$2, () => [[["ResultValue", GenericResponse_$reflection()]], [["ErrorValue", FetchError_$reflection()]]])]], []]);
}

function init(token) {
    return new Model(token, new ValidateState(0, []), new ActivateState(0, []), "", "", undefined);
}

function update(model, msg) {
    let y;
    switch (msg.tag) {
        case 1:
            return new Model(model.Token, model.Validate, model.Activate, model.Password, msg.fields[0], model.ErrorMsg);
        case 2: {
            const res = msg.fields[0];
            if (res.tag === 1) {
                const err = res.fields[0];
                let matchResult, y_1;
                if (err.tag === 2) {
                    if ((y = err.fields[0], ((y.status) === 410) ? true : ((y.status) === 409))) {
                        matchResult = 0;
                        y_1 = err.fields[0];
                    }
                    else {
                        matchResult = 1;
                    }
                }
                else {
                    matchResult = 1;
                }
                switch (matchResult) {
                    case 0:
                        return new Model(model.Token, new ValidateState(2, []), model.Activate, model.Password, model.PasswordRepeat, model.ErrorMsg);
                    default:
                        return new Model(model.Token, new ValidateState(3, ["Kunne ikke validere aktiveringslenken. Vennligst prøv igjen senere."]), model.Activate, model.Password, model.PasswordRepeat, model.ErrorMsg);
                }
            }
            else {
                const x_2 = res.fields[0];
                if (x_2.Result === "success") {
                    return new Model(model.Token, new ValidateState(1, []), model.Activate, model.Password, model.PasswordRepeat, model.ErrorMsg);
                }
                else {
                    return new Model(model.Token, new ValidateState(3, [x_2.Message]), model.Activate, model.Password, model.PasswordRepeat, model.ErrorMsg);
                }
            }
        }
        case 3: {
            const res_1 = msg.fields[0];
            if (res_1.tag === 1) {
                return new Model(model.Token, model.Validate, new ActivateState(3, ["Kunne ikke aktivere konto. Vennligst prøv igjen senere."]), model.Password, model.PasswordRepeat, model.ErrorMsg);
            }
            else {
                const x_3 = res_1.fields[0];
                if (x_3.Result === "success") {
                    return new Model(model.Token, model.Validate, new ActivateState(2, []), model.Password, model.PasswordRepeat, model.ErrorMsg);
                }
                else {
                    return new Model(model.Token, model.Validate, new ActivateState(3, [x_3.Message]), model.Password, model.PasswordRepeat, model.ErrorMsg);
                }
            }
        }
        case 4:
            return new Model(model.Token, model.Validate, model.Activate, model.Password, model.PasswordRepeat, undefined);
        default:
            return new Model(model.Token, model.Validate, model.Activate, msg.fields[0], model.PasswordRepeat, model.ErrorMsg);
    }
}

function tryValidate(token, dispatch) {
    const pr_2 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let pr_1, decoder, data_1, caseStrategy_2, extra_2;
        return ((pr_1 = ((decoder = Auto_generateBoxedDecoder_Z6670B51(GenericResponse_$reflection(), undefined, undefined), (data_1 = undefined, (caseStrategy_2 = undefined, (extra_2 = extraCoders, (() => {
            let properties_2;
            try {
                const properties_3 = Helper_withProperties(undefined, (properties_2 = ofArray([new Types_RequestProperties(0, ["GET"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty()), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_2), unwrap(extra_2))(data_1_1))]), properties_2), data_1), properties_2)));
                const pr = PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Helper_fetch(`/api/activation/validate?token=${token}`, properties_3).then((_arg) => {
                    let response_1, decoder_1_1;
                    return ((response_1 = _arg, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(GenericResponse_$reflection(), unwrap(caseStrategy_2), unwrap(extra_2))), PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (response_1.text().then((_arg_1) => {
                        let matchValue;
                        return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_1), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
                    })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
                }))));
                return pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])]))));
            }
            catch (exn) {
                return PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
            }
        })()))))), pr_1.then((result_1) => Result_MapError(testRedirect, result_1)))).then((_arg_2) => {
            dispatch(new Message(2, [_arg_2]));
            return Promise.resolve();
        });
    }));
    pr_2.then();
}

function tryActivate(token, password, dispatch) {
    const pr_1 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let body, decoder, data_1, caseStrategy_3, extra_3;
        const req = new LoginRequest(token, password);
        return ((body = Auto_generateBoxedEncoder_437914C6(LoginRequest_$reflection(), undefined, undefined, undefined)(req), (decoder = Auto_generateBoxedDecoder_Z6670B51(GenericResponse_$reflection(), undefined, undefined), (data_1 = some(body), (caseStrategy_3 = undefined, (extra_3 = undefined, (() => {
            let properties_2;
            try {
                const properties_3 = Helper_withProperties(corsProps, (properties_2 = ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty()), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_3), unwrap(extra_3))(data_1_1))]), properties_2), data_1), properties_2)));
                const pr = PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Helper_fetch(`/api/activation/activate?token=${token}`, properties_3).then((_arg) => {
                    let response_1, decoder_1_1;
                    return ((response_1 = _arg, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(GenericResponse_$reflection(), unwrap(caseStrategy_3), unwrap(extra_3))), PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (response_1.text().then((_arg_1) => {
                        let matchValue;
                        return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_1), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
                    })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
                }))));
                return pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])]))));
            }
            catch (exn) {
                return PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
            }
        })())))))).then((_arg_2) => {
            dispatch(new Message(3, [_arg_2]));
            return Promise.resolve();
        });
    }));
    pr_1.then();
}

export function Activate(activateInputProps) {
    let elems_3, elements;
    const token = activateInputProps.token;
    let patternInput;
    const arg_1 = init(token);
    patternInput = reactApi.useReducer(update, arg_1);
    const model_1 = patternInput[0];
    const dispatch = patternInput[1];
    useEffectOnce(() => {
        tryValidate(token, dispatch);
    });
    return createElement("div", createObj(ofArray([["style", {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: 100 + "%",
        minHeight: 75 + "vh",
    }], (elems_3 = [MuiHelpers_createElement(Paper, [["elevation", 1], ["style", {
        padding: 20,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
    }], (elements = toList(delay(() => {
        let elems;
        return append(singleton(createElement("div", createObj(ofArray([["style", {
            display: "flex",
            justifyContent: "center",
            marginBottom: 20,
            maxWidth: 350,
            backgroundColor: "hsl(207.3, 30.8%, 21%)",
            padding: 20,
            borderRadius: 5,
        }], (elems = [createElement("img", {
            style: {
                width: 100 + "%",
            },
            src: "/logo.png",
        })], ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => {
            const matchValue = model_1.Validate;
            switch (matchValue.tag) {
                case 2:
                    return singleton(createElement("span", {
                        children: ["Aktiveringslenke utløpt eller ugyldig"],
                    }));
                case 3:
                    return singleton(createElement("span", {
                        children: [matchValue.fields[0]],
                    }));
                case 1: {
                    const matchValue_1 = model_1.Activate;
                    return (matchValue_1.tag === 3) ? singleton(createElement("span", {
                        children: [matchValue_1.fields[0]],
                    })) : ((matchValue_1.tag === 2) ? append(singleton(createElement("span", {
                        style: {
                            fontSize: 1.4 + "rem",
                            marginBottom: 20,
                        },
                        children: "Bruker aktivert",
                    })), delay(() => singleton(createElement("a", {
                        style: {
                            textDecoration: "underline",
                            cursor: "pointer",
                        },
                        onClick: (_arg_1) => {
                            RouterModule_nav(singleton_1(""), 1, 2);
                        },
                        children: "Til innlogging",
                    })))) : ((matchValue_1.tag === 0) ? append(singleton(createElement("span", {
                        style: {
                            marginBottom: 20,
                        },
                        children: "Sett ett passord for denne brukeren.",
                    })), delay(() => append(singleton(MuiHelpers_createElement(TextField, [["type", "password"], ["id", "pw"], ["autoFocus", true], ["label", "Passord"], ["variant", "outlined"], ["fullWidth", true], ["onChange", (e) => {
                        dispatch(new Message(0, [e.target.value]));
                    }], ["defaultValue", model_1.Password], ["helperText", "Minst 8 tegn"], ["style", {
                        marginBottom: 20,
                    }]])), delay(() => append(singleton(MuiHelpers_createElement(TextField, toList(delay(() => append(singleton(["type", "password"]), delay(() => append(singleton(["id", "pw-repeat"]), delay(() => append(singleton(["label", "Gjenta passord"]), delay(() => append(singleton(["variant", "outlined"]), delay(() => append(singleton(["fullWidth", true]), delay(() => append(singleton(["onChange", (e_1) => {
                        dispatch(new Message(1, [e_1.target.value]));
                    }]), delay(() => append(singleton(["defaultValue", model_1.PasswordRepeat]), delay(() => append(((model_1.PasswordRepeat.length > 0) && (model_1.Password !== model_1.PasswordRepeat)) ? singleton(["helperText", "Passord er ikke like"]) : singleton(["helperText", ""]), delay(() => singleton(["style", {
                        marginBottom: 20,
                    }]))))))))))))))))))))), delay(() => {
                        let elems_1;
                        return singleton(createElement("div", createObj(ofArray([["style", {
                            display: "flex",
                            justifyContent: "center",
                        }], (elems_1 = [createElement("button", {
                            disabled: (model_1.Password.length < 8) ? true : (model_1.Password !== model_1.PasswordRepeat),
                            style: createObj(toList(delay(() => append(singleton(["border", "none"]), delay(() => append(((model_1.Password.length < 8) ? true : (model_1.Password !== model_1.PasswordRepeat)) ? append(singleton(["opacity", 0.2]), delay(() => singleton(["cursor", "not-allowed"]))) : singleton(["cursor", "pointer"]), delay(() => append(singleton(["backgroundColor", "hsl(207.3, 30.8%, 21%)"]), delay(() => append(singleton(["width", 150]), delay(() => append(singleton(["color", "#FFFFFF"]), delay(() => append(singleton(["padding", 10]), delay(() => append(singleton(["fontSize", 16 + "px"]), delay(() => singleton(["borderRadius", 5])))))))))))))))))),
                            onClick: (_arg_2) => {
                                if ((model_1.Password.length >= 8) && (model_1.Password === model_1.PasswordRepeat)) {
                                    tryActivate(token, model_1.Password, dispatch);
                                }
                            },
                            children: "Aktiver bruker",
                        })], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))));
                    })))))) : singleton(loadingIndicator())));
                }
                default:
                    return singleton(loadingIndicator());
            }
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elements))])])], ["children", reactApi.Children.toArray(Array.from(elems_3))])])));
}

